/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TimeInputs */

const th_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลา`)
};

const en_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const ja_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時刻`)
};

const zh_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间`)
};

const es_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const pt_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horário`)
};

const id_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu`)
};

const fr_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure`)
};

const tl_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oras`)
};

const vi_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ`)
};

const ko_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시각`)
};

const de_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit`)
};

const ru_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время`)
};

const tr_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat`)
};

const it_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora`)
};

const pl_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godzina`)
};

const uk_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час`)
};

const hi_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय`)
};

const ar_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوقت`)
};

const ms_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa`)
};

const bn_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সময়`)
};

const zh_tw2_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

const zh_hk2_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

const ur_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت`)
};

const fa_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمان`)
};

const sw_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa`)
};

const nl_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijd`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {TimeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const time = /** @type {((inputs?: TimeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TimeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_time(inputs)
	if (locale === "ja") return ja_time(inputs)
	if (locale === "zh") return zh_time(inputs)
	if (locale === "es") return es_time(inputs)
	if (locale === "pt") return pt_time(inputs)
	if (locale === "id") return id_time(inputs)
	if (locale === "fr") return fr_time(inputs)
	if (locale === "tl") return tl_time(inputs)
	if (locale === "vi") return vi_time(inputs)
	if (locale === "ko") return ko_time(inputs)
	if (locale === "de") return de_time(inputs)
	if (locale === "ru") return ru_time(inputs)
	if (locale === "tr") return tr_time(inputs)
	if (locale === "it") return it_time(inputs)
	if (locale === "pl") return pl_time(inputs)
	if (locale === "uk") return uk_time(inputs)
	if (locale === "hi") return hi_time(inputs)
	if (locale === "ar") return ar_time(inputs)
	if (locale === "ms") return ms_time(inputs)
	if (locale === "bn") return bn_time(inputs)
	if (locale === "zh-TW") return zh_tw2_time(inputs)
	if (locale === "zh-HK") return zh_hk2_time(inputs)
	if (locale === "ur") return ur_time(inputs)
	if (locale === "fa") return fa_time(inputs)
	if (locale === "sw") return sw_time(inputs)
	if (locale === "nl") return nl_time(inputs)
	return en_time(inputs)
});